<div class="modal-header" *ngIf="showAsDialog">
    <h4 class="modal-title">Detail Search</h4>
</div>
<div class="flex-fill d-flex flex-column" [ngStyle]="{ height: showAsDialog ? '1000px' : '100%' }">
    <div class="card">
        <div class="card-body" style="max-width: 1550px">
            <dx-form [formData]="filter" appAutofocusForm="salesOrderNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <dxi-item
                        dataField="typeId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Type' }"
                        [editorOptions]="{ items: types, valueExpr: 'id', displayExpr: 'name' }"
                    ></dxi-item>
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName' }"
                    ></dxi-item>
                    <dxi-item dataField="salesOrderNumber" editorType="dxNumberBox" [label]="{ text: 'Sales Order #' }"></dxi-item>
                    <!-- <dxi-item dataField="partNumber"></dxi-item> -->
                    <!-- <dxi-item dataField="orderLineDetailField" [label]="{ text: 'Detail Id ( , for multiple)' }"></dxi-item> -->
                    <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group">
                    <!-- <dxi-item
                        dataField="typeId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Type' }"
                        [editorOptions]="{ items: types, valueExpr: 'id', displayExpr: 'name' }"
                    ></dxi-item>
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName' }"
                    ></dxi-item>
                    <dxi-item dataField="salesOrderNumber" editorType="dxNumberBox" [label]="{ text: 'Sales Order #' }"></dxi-item> -->
                    <dxi-item dataField="partNumber"></dxi-item>
                    <dxi-item dataField="orderLineDetailField" [label]="{ text: 'Detail Id ( , for multiple)' }"></dxi-item>
                    <dxi-item dataField="vin" [label]="{ text: 'VIN' }"></dxi-item>
                    <!-- <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item> -->
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                    <dxi-item dataField="buildStart" editorType="dxDateBox" [label]="{ text: 'Built From' }"></dxi-item>
                    <dxi-item dataField="buildEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <dxi-item dataField="orderStart" editorType="dxDateBox" [label]="{ text: 'Ordered From' }"></dxi-item>
                    <dxi-item dataField="orderEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <!-- <dxi-item dataField="vin" [label]="{ text: 'VIN' }"></dxi-item> -->
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item dataField="packingSlipNumber" editorType="dxNumberBox" [label]="{ text: 'Pack Slip #' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end align-items-center">
                <div *ngIf="orderHistory" class="me-3">{{ orderHistory.length }} {{ orderHistory.length === 1 ? 'item found' : 'items found' }}</div>
                <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button (click)="clear()" class="btn btn-light ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div *ngIf="orderHistory" class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="orderHistory"
            keyExpr="id"
            [columnAutoWidth]="false"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
        >
            <!-- <dxi-column width="40" cellTemplate="faTemplate"> </dxi-column> -->
            <dxi-column dataField="id" width="45"></dxi-column>
            <dxi-column dataField="orderNumber" caption="Order #" width="80" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="poNumber" caption="PO #" width="80" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="type" width="80"></dxi-column>
            <dxi-column dataField="shippingNotes" width="80"></dxi-column>
            <dxi-column dataField="dealer" width="100" [sortIndex]="0" sortOrder="asc"></dxi-column>
            <dxi-column dataField="city" width="100"></dxi-column>
            <dxi-column dataField="state" width="45"></dxi-column>
            <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" width="65"></dxi-column>
            <dxi-column dataField="partNumber" caption="Part #" width="125" cellTemplate="partNumberTemplate"></dxi-column>
            <dxi-column dataField="description" caption="Desc" width="125"></dxi-column>
            <dxi-column dataField="slipNumber" caption="Slip #" width="125" cellTemplate="printTemplate"></dxi-column>
            <dxi-column dataField="invoiceNumber" caption="Invoice #" width="125" cellTemplate="printTemplate"></dxi-column>
            <dxi-column dataField="invoiceTotal" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
            <dxi-column dataField="noteHTML" caption="Notes" width="250" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
            <dxi-column dataField="status" width="100"></dxi-column>
            <dxi-column dataField="vin" caption="Vin #" width="100"></dxi-column>
            <dxi-column dataField="vinEndingDisplay" caption="Vin Last 7" width="100"></dxi-column>
            <dxi-column dataField="orderDate" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="confirmationApproved" caption="Confirmation" dataType="date" format="shortDate" width="120"></dxi-column>
            <dxi-column dataField="built" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="buildDue" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="dueDate" caption="Ship Due" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="delivery" width="100"></dxi-column>
            <dxi-column dataField="optionHTML" caption="Options" width="250" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
            <dxi-column dataField="deleted" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="delivered" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="orderTotal" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
            <!-- <dxi-column dataField="freight" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column> -->
            <dxi-column dataField="pricingTier" width="100"></dxi-column>

            <div *dxTemplate="let item of 'partNumberTemplate'">
                <div title="{{ item.data.description }}">{{ item.data.partNumber }}</div>
            </div>
            <div *dxTemplate="let item of 'faTemplate'" class="d-flex">
                <i *ngIf="item.data.paidViaACH" class="fa fa-usd ms-2" style="color: #1b8600" title="Paid via ACH"></i>
            </div>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="'/sales-orders/' + cell.data.orderId">{{ cell.value || '(blank)' }}</a>
            </div>
            <div *dxTemplate="let cell of 'printTemplate'">
                <a [routerLink]="[]" (click)="printPDF(cell)">{{ cell.value || '' }}</a>
            </div>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="order-history-grid"></dxo-state-storing>
            <dxo-selection [mode]="showAsDialog ? 'single' : 'multiple'"></dxo-selection>

            <dxo-summary>
                <dxi-total-item column="invoiceTotal" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
            </dxo-summary>

            <div *dxTemplate="let data of 'toolbarButtons'">
                .
                <button [hidden]="showAsDialog" class="btn btn-sm btn-success ms-2" (click)="printBuildList()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                    Build List
                </button>
                <button
                    class="btn btn-sm btn-success ms-2"
                    (click)="addToStock()"
                    [hidden]="showAsDialog || !canAllocateStock"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Add To Stock
                </button>
                <button
                    class="btn btn-sm btn-primary ms-2"
                    (click)="updateStatus(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    [hidden]="showAsDialog || !canUpdateStatus"
                >
                    Update Status
                </button>
                <button [hidden]="showAsDialog" class="btn btn-sm btn-success ms-2" (click)="addNote()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                    Add Note
                </button>
                <button
                    [hidden]="showAsDialog"
                    class="btn btn-sm btn-secondary ms-1"
                    (click)="printMsrp(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Print MSRP
                </button>
                <button
                    [hidden]="showAsDialog"
                    class="btn btn-sm btn-success ms-3"
                    (click)="msoMailed()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    MSO Mailed
                </button>
                <button
                    [hidden]="showAsDialog"
                    class="btn btn-sm btn-success ms-1"
                    (click)="duplicateMSO()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    Duplicate MSO
                </button>
                <button
                    class="btn btn-sm btn-danger ms-3"
                    (click)="newWarranty()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="showAsDialog || !canStartWarranty"
                >
                    Start Warranty
                </button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="adjustBuiltDate()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || !dataGrid.instance.getSelectedRowsData()[0].built"
                    [hidden]="showAsDialog || !canAdjustBuiltAndDeliveredDates"
                >
                    Adjust Built Date
                </button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="adjustDeliveredDate()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || !dataGrid.instance.getSelectedRowsData()[0].delivered"
                    [hidden]="showAsDialog || !canAdjustBuiltAndDeliveredDates"
                >
                    Adjust Delivered Date
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="orderHistory" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
<div *ngIf="showAsDialog" class="modal-footer">
    <button class="btn btn-success ms-1" (click)="saveDialog()">Assign Selected Detail</button>
    <button class="btn btn-secondary ms-1" (click)="closeDialog()">Close</button>
</div>
